"use strict";
import moment from 'moment';

const ExportSettingsCtrl = function (CRUDService, $q, $http) {
  var ctrl = this;
  this.$q = $q;
  this.$http = $http;

  ctrl.downloadBtnDisabled = false;

  ctrl.$onInit = function () {

  };

  ctrl.doExport = function (type) {
    ctrl.downloadBtnDisabled = true;
    var deferred = this.$q.defer();

    this.$http.get("/api/export", { params: {type: type}, responseType: 'arraybuffer' }).then(
      function (response) {
        if (response.status === 200) {
          let date = moment().format('YYYYMMDD_HHmm');
          ctrl.download(response.data, "MDAT_Export_"+date+".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
          deferred.resolve();
          ctrl.downloadBtnDisabled = false;
        } else {
          deferred.reject();
          ctrl.downloadBtnDisabled = false;
        }
      },
      function () {
        deferred.reject();
        ctrl.downloadBtnDisabled = false;
      });
    return deferred.promise;
  };


  ctrl.download = function (data, filename, mime) {
    var blob = new Blob([data], { type: mime || 'application/octet-stream' });
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // IE workaround for "HTML7007: One or more blob URLs were 
      // revoked by closing the blob for which they were created. 
      // These URLs will no longer resolve as the data backing 
      // the URL has been freed."
      window.navigator.msSaveBlob(blob, filename);
    }
    else {
      var blobURL = window.URL.createObjectURL(blob);
      var tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', filename);

      // Safari thinks _blank anchor are pop ups. We only want to set _blank
      // target if the browser does not support the HTML5 download attribute.
      // This allows you to download files in desktop safari if pop up blocking 
      // is enabled.
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
      }

      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }
  }



};

ExportSettingsCtrl.$inject = ['CRUDService', '$q', '$http'];

module.exports = {
  template: require('./export.html'),
  controller: ExportSettingsCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/settings/components/export/export.component.js